export default __webpack_public_path__ + "static/media/sales_reporting.f7226671.svg";